import { useState } from 'react';
import Container from 'react-bootstrap/Container';
import classnames from 'classnames';

import { AdmissionPolicy, GuestPolicy, ReservationPolicy } from './';

import './Policy.css';

export function Policy(props) {
    const [ item, setItem ] = useState(0);

    const policies = [
        { title: "Reservation Policies", policy: <ReservationPolicy /> },
        { title: "Guest Policies", policy: <GuestPolicy /> },
        { title: "Admission Policies", policy: <AdmissionPolicy /> },
    ]

    const displayPolicies = policies.map((x, i) =>
        <div className="policy-section info-panel" key={i}>
            <h1 onClick={() => setItem(i)}>{x.title}</h1>
            <div className={classnames({ active: item === i })}>
                {x.policy}
            </div>
        </div>
    )

    return (
        <Container>
            {displayPolicies}
        </Container>
    );

}


